import { useDispatch as untypedUseDispatch } from 'react-redux'

import type { AppDispatch } from 'src/store'

// Use throughout your app instead of plain `useDispatch`
export const useDispatch: () => AppDispatch = untypedUseDispatch
